import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import { ButtonProps } from '@boss/types/b2b-b2c';

import ButtonOrAnchor from '../_Button';

const ButtonStyles = cva('flex items-center text-center justify-center p-4 button gap-3', {
  variants: {
    type: {
      primary:
        'bg-white border-1 border-solid border-textColor text-textColor hover:text-white hover:border-white hover:bg-textColor',
      secondary: 'bg-white text-ctaBanner hover:bg-ctaBanner hover:text-white',
      tertiary: 'bg-ctaBanner text-white hover:bg-white hover:text-ctaBanner',
      link: 'text-black-rich border-b-1 border-b-solid border-b-brand pb-2 px-0 uppercase',
      mobileMenu:
        'bg-white text-textColor hover:bg-black hover:text-white hover:border-1 hover:border-solid hover:border-white',
    },
  },
});

const Button = ({
  alternativeText,
  anchorClassName,
  className,
  fileToDownload,
  hideLabel,
  href,
  icon,
  iconPosition,
  label,
  labelClassName,
  onClick,
  onKeyDown,
  submitButton,
  testId,
  type,
  trackInfo,
}: ButtonProps) => (
  <ButtonOrAnchor
    alternativeText={alternativeText}
    anchorClassName={anchorClassName}
    className={twMerge(ButtonStyles({ type }), className)}
    fileToDownload={fileToDownload}
    href={href}
    onClick={onClick}
    onKeyDown={onKeyDown}
    submitButton={submitButton}
    testId={testId}
    trackInfo={trackInfo}
  >
    {icon && iconPosition === 'left' && <FontAwesomeIcon icon={icon} />}
    {!hideLabel && label && <span className={twMerge('w-full', labelClassName)}>{label}</span>}
    {icon && iconPosition === 'right' && <FontAwesomeIcon icon={icon} />}
  </ButtonOrAnchor>
);

export default Button;
